import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, nextTick } from 'vue'
import { SyncPathsArr } from '@/enum/SyncPath'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailFtp',
  props: {
    fleet: null
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
};



const configFtp = computed(() => store.state.fleet.context?.configFtp)

onMounted(() => {
  if (!store.state.fleet.context?.configFtp || store.state.fleet.context.configFtp.idFleet != props.fleet.id) {
    restoreConfigFtp()
  }
})

const saving = ref(false)

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

function restoreConfigFtp() {
  store.state.fleet.context.configFtp = {
    idFleet: props.fleet.id,
    login: '',
    password: '',
    port: 21,
    server: '',
    tls: true,
    dstPaths: '',
    syncPaths: [] as string[]
  }
}

async function applyToAll() {
  if (saving.value) return
  saving.value = true

  for (const mission of missions.value.filter((m) => m.misActifOn)) {
    if (mission.gliId == null) return
    try {
      await store.myActions.GLIDER_IRIS_FTP_REQUEST(mission.gliId!)
      await store.myActions.GLIDER_UPDATE_MODIFIED_FTP({
        itemId: mission.gliId!,
        newProperties: {
          mod_settings: {
            FTP: {
              login: configFtp.value.login,
              password: configFtp.value.password,
              port: configFtp.value.port,
              server: configFtp.value.server,
              tls: configFtp.value.tls
            },
            Data: {
              dst_paths: configFtp.value.dstPaths,
              sync_paths: configFtp.value.syncPaths.filter((p: any) => SyncPathsArr.some((pa) => pa == p))
            }
          }
        }
      })
      await store.myActions.GLIDER_IRIS_FTP_SAVE_REQUEST(mission.gliId!)
    } catch (e) {
      console.error(e)
    }
  }
  nextTick(() => {
    restoreConfigFtp()
    saving.value = false
  })
}

return { __sfc: true,props, configFtp, saving, missions, restoreConfigFtp, applyToAll, SyncPathsArr }
}

})